export const LANG_TO_LOCALE = {
  de: 'de_DE_lock',
  en: 'en',
  es: 'es_LA',
  fr: 'fr_FR_lock',
  pt: 'pt_PT_lock',
} as const;

export const DEFAULT_LOCALE = 'en';
